import { useTeamConfig } from "./useTeamConfig";

import type { PurchaseSeatCheckoutPayload } from "../api/cart";

export function useMetaPixelTracking() {
  const { analyticsConfigs } = useTeamConfig();

  // prettier-ignore
  function metaPixelTrackSuccessPurchase(checkoutData: PurchaseSeatCheckoutPayload) {
    if (!analyticsConfigs?.metaPixelId || !analyticsConfigs?.trackMetaPixelOnCheckout) return;

    window.fbq("track", "Purchase", {
      value: checkoutData.allInPrice,
      currency: "USD",
    });
  }

  return { metaPixelTrackSuccessPurchase };
}
